import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useDataContext } from '../../../../../context';
import { NumberInput } from '../../../../../components/inputs/NumberInput';
import { StepProps } from './AddEditPromotionalCode';

export const PromotionalCodeForm = ({
  touched,
  errors,
  showLocationField = true
}: StepProps) => {
  const { locationOptions } = useDataContext();

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Promotional Code Details" />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="name"
          >
            <FormLabel required>Name</FormLabel>
            <Field
              name="name"
              type="text"
              as={Form.Control}
              isInvalid={touched.name && !!errors.name}
              aria-required
            />
            <ErrorMessage name="name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          {showLocationField && (
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="location_id"
            >
              <Field
                as={FormSelect}
                name="location_id"
                label="Location"
                options={locationOptions}
              />
            </Form.Group>
          )}

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="code"
          >
            <FormLabel required>Code</FormLabel>
            <Field
              name="code"
              type="text"
              as={Form.Control}
              isInvalid={touched.code && !!errors.code}
              aria-required
            />
            <ErrorMessage name="code">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="percent_discount"
          >
            <FormLabel required>Percent Discount</FormLabel>
            <Field
              name="percent_discount"
              min={1}
              as={NumberInput}
              isInvalid={touched.percent_discount && !!errors.percent_discount}
              aria-required
            />
            <ErrorMessage name="percent_discount">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="expiration_date"
          >
            <FormLabel>Expiration date</FormLabel>
            <Field
              name="expiration_date"
              type="date"
              as={Form.Control}
              isInvalid={touched.expiration_date && !!errors.expiration_date}
            />
            <ErrorMessage name="expiration_date">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="is_active"
          >
            <Form.Label>
              <Field
                name="is_active"
                type="checkbox"
                as={Form.Check}
                label="Is active"
              />
            </Form.Label>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
